//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 30.09.2015.
 */

(function () {

    'use strict';

    angular.module('container.core', []);

})();